import { useCallback, useEffect } from 'react';

import { type BingoCompletion } from '@/common/types/bingo';
import { addCompletion } from '@/redux/reducers/bingoReducer';
import { useAppDispatch } from '@/redux/store';

import { WebsocketEmitters } from '../app/socket';
import { socket } from '../socket/socket';

const useBingoCompletionListener = (): void => {
  const dispatch = useAppDispatch();

  const handleCompletion = useCallback(
    (data: BingoCompletion) => {
      dispatch(addCompletion(data));
    },
    [dispatch],
  );

  useEffect(() => {
    socket.on(WebsocketEmitters.BINGO_COMPLETION, handleCompletion);

    return (): void => {
      socket.off(WebsocketEmitters.BINGO_COMPLETION, handleCompletion);
    };
  }, [handleCompletion]);
};

export { useBingoCompletionListener };
